var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChildHelpLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CHILD_HELP_LINES",
    "data-name": "CHILD HELP LINES",
    transform: "translate(-1375 -352)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4272",
    "data-name": "Rectangle 4272",
    width: 93,
    height: 93,
    rx: 10,
    transform: "translate(1375 352)",
    fill: "#fff9e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "help_1_",
    "data-name": "help (1)",
    d: "M20.116,27.916a3.081,3.081,0,0,0-.234.292,1.482,1.482,0,0,0-.176.351,1.248,1.248,0,0,0-.117.351,2.652,2.652,0,0,0,0,.39,1.638,1.638,0,0,0,.156.741A1.755,1.755,0,0,0,20.8,31.094a1.833,1.833,0,0,0,1.482,0,1.755,1.755,0,0,0,1.053-1.053,1.968,1.968,0,0,0-3.217-2.126ZM21.5,2A19.5,19.5,0,1,0,41,21.5,19.5,19.5,0,0,0,21.5,2Zm0,35.1A15.6,15.6,0,1,1,37.1,21.5,15.6,15.6,0,0,1,21.5,37.1Zm0-25.35a5.85,5.85,0,0,0-5.07,2.925,1.95,1.95,0,1,0,3.373,1.95,1.953,1.953,0,1,1,1.7,2.925,1.95,1.95,0,0,0-1.95,1.95v1.95a1.95,1.95,0,1,0,3.9,0V23.1A5.85,5.85,0,0,0,21.5,11.75Z",
    transform: "translate(1400 377)",
    fill: "#b28400"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildHelpLines);
export default __webpack_public_path__ + "static/media/CHILD-HELP-LINES.b4e927b3bbc991b845e39bbff4a7f375.svg";
export { ForwardRef as ReactComponent };